/* eslint-disable no-magic-numbers */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import Header from "./component";
import {
    selectCity,
    updateC2CPromotionFlag,
    resetCities
} from "../../../components/desktop/cities/actions";
import { toggleLocationPicker } from "../../desktop/location-picker-popup/actions";

const mapStateToProps = ({
    location: { pincode, cityInfo },
    cities: { selectedCity, isCitySelectionSSR },
    meta: { templateType },
    user: { isFetched, unAuthorized, checkAuth },
    config: { cityList: cities },
    settings: { isCitySelectionSkipped }
}) => ({
    selectedCity,
    isFetched,
    unAuthorized,
    checkAuth,
    templateType,
    isCitySelectionSkipped,
    cities,
    isCitySelectionSSR,
    pincode,
    cityInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    selectCityConnect: selectCity,
    updateC2CPromotionFlagConnect: updateC2CPromotionFlag,
    resetCitiesConnect: resetCities,
    toggleLocationPickerConnect: toggleLocationPicker
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
